import {
    Box,
    Stack,
    Step,
    StepLabel,
    Stepper,
    Typography,
} from "@mui/material";

import { DiagnosticsMetricsIndicator } from "./types/DiagnosticsMetricsIndicator";

export interface DiagnosticsMetricsIndicatorsProps {
    diagnosticsMetricsIndicators: DiagnosticsMetricsIndicator[];
}

export function DiagnosticsMetricsIndicators(
    props: DiagnosticsMetricsIndicatorsProps,
) {
    return (
        <Stack
            sx={{ width: "100%", marginBottom: 8 }}
            spacing={4}
        >
            <Stepper
                activeStep={
                    props.diagnosticsMetricsIndicators.filter((x) => x.duration)
                        .length
                }
                alternativeLabel
            >
                {props.diagnosticsMetricsIndicators.map(
                    (diagnosticsMetricsIndicators, index) => (
                        <Step
                            key={
                                diagnosticsMetricsIndicators.label + "-" + index
                            }
                        >
                            <StepLabel
                                error={diagnosticsMetricsIndicators.error}
                                sx={{
                                    // Icon color for completed (green) and error (red)
                                    "& .MuiStepIcon-root.Mui-completed": {
                                        color: "green",
                                    },
                                    "& .MuiStepIcon-root.Mui-error": {
                                        color: "red",
                                    },
                                    "& .MuiStepIcon-root": {
                                        color:
                                            diagnosticsMetricsIndicators.duration ===
                                                undefined ||
                                            diagnosticsMetricsIndicators.duration <
                                                1 ||
                                            diagnosticsMetricsIndicators.duration ===
                                                null
                                                ? "gray"
                                                : "#1976d2",
                                    },
                                }}
                            >
                                {diagnosticsMetricsIndicators.label}
                                <Box>
                                    <Typography fontSize={"0.9rem"}>
                                        {
                                            diagnosticsMetricsIndicators.description
                                        }
                                    </Typography>
                                    {diagnosticsMetricsIndicators.duration && (
                                        <Typography fontSize={"0.9rem"}>
                                            Duration:{" "}
                                            {diagnosticsMetricsIndicators.duration.toFixed(
                                                0,
                                            )}{" "}
                                            ms <br />
                                            {diagnosticsMetricsIndicators.durationToFirstChild &&
                                                diagnosticsMetricsIndicators.durationBackFromLastChild && (
                                                    <>
                                                        Request to cluster:{" "}
                                                        {diagnosticsMetricsIndicators.durationToFirstChild?.toFixed(
                                                            0,
                                                        )}{" "}
                                                        ms
                                                        <br />
                                                        Response from cluster:{" "}
                                                        {diagnosticsMetricsIndicators.durationBackFromLastChild?.toFixed(
                                                            0,
                                                        )}{" "}
                                                        ms
                                                    </>
                                                )}
                                        </Typography>
                                    )}
                                </Box>
                            </StepLabel>
                        </Step>
                    ),
                )}
            </Stepper>
        </Stack>
    );
}
